import type { ProficiencyLevel } from '@/types/competencies/ProficiencyLevel';
import type { PerformanceScoreLevel } from '@/types/competency/PerformanceScoreLevel';

export type { ProficiencyLevel };

export interface HandoutPredefinedSectionData {
    id: string;
    presetKey?: string;
    title: string;
    content: string;
}

export interface ReviewDiscussionData {
    id: string;
    reviewInstanceId: string;
    performanceScoreOverride?: string;
    valueAlignmentScoreOverride?: string;
    overallPerformanceLevelId?: string | null;
    overallPerformanceLevelSnapshot?: string | null;
    calculatedPerformanceScore?: number | null;
    calculatedPerformanceLabel?: string | null;
    calculatedValueAlignmentScore?: number | null;
    handoutAnnotations?: string;
    agendaTopics?: string;
    predefinedSection?: string;
    transcriptText?: string;
    transcriptSummary?: string;
}

export interface ReviewDiscussionUpdatePayload {
    performanceScoreOverride?: string;
    overallPerformanceLevelId?: string | null;
    valueAlignmentScoreOverride?: string;
    handoutAnnotations?: string;
    agendaTopics?: string;
    predefinedSection?: string;
    transcriptText?: string;
    transcriptSummary?: string;
}

export interface HandoutCompanyValueData {
    id: string;
    name: Record<string, string>;
    description?: Record<string, string>;
    icon?: string;
    iconBackground?: string;
    assessedScore: number;
    maxScore: number;
    proficiencyLevelId?: string;
}

export interface HandoutPreviewData {
    reviewInstanceId: string;
    employeeName: string;
    employeeRole: string;
    employeeProfile?: string;
    employeeAvatarUrl?: string;
    managerName?: string;
    evaluationDate?: string;
    evaluationStartDate?: string;
    evaluationEndDate?: string;
    evaluationPeriodId?: string | null;
    performanceScore?: string;
    overallPerformanceLevelId?: string | null;
    overallPerformanceLevel?: PerformanceScoreLevel | null;
    valuesAlignment?: string;
    competencyGroups: CompetencyGroup[];
    proficiencyLevels: ProficiencyLevel[];
    companyValues?: HandoutCompanyValueData[];
    predefinedSection?: HandoutPredefinedSectionData[];
}

export const defaultHandoutPreviewData: HandoutPreviewData = {
    reviewInstanceId: '',
    employeeName: '',
    employeeRole: '',
    employeeProfile: '',
    managerName: '',
    evaluationDate: '',
    evaluationStartDate: '',
    evaluationEndDate: '',
    evaluationPeriodId: null,
    performanceScore: '',
    overallPerformanceLevelId: null,
    overallPerformanceLevel: null,
    valuesAlignment: '',
    competencyGroups: [],
    proficiencyLevels: [],
    companyValues: [],
    predefinedSection: [],
};

export interface CompetencyGroup {
    id: string;
    name: string;
    competencies: CompetencyDto[];
}

export interface CompetencyDto {
    id: string;
    name: string;
    assessedScore: number;
    description?: string;
    lastAssessedAt?: string | null;
    proficiencyLevelId?: string;
    isDeactivated?: boolean;
    isDeleted?: boolean;
}

export interface AiAgendaResponse {
    agendaTopics: string;
}

export interface TranscriptUploadResponse {
    transcriptSummary: string;
}
